export default "__VITE_ASSET__QnQMJtLj__"